import classNames from "classnames/bind";
import styles from "../../CaseChatCard.module.scss";

const cx = classNames.bind(styles);

function CasePendingCard({ 
    avatarUrl,
    senderName,
    caseCreatedDate,
    castType,
    onClick,
    active
}) {
    return (
        <div 
            onClick={onClick} 
            className={cx("case-card", active ? "case-card-active" : "")}
        >
            <div className="d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle overflow-hidden bg-light" style={{ width: "36px", height: "36px" }}>
                {avatarUrl ? (
                    <img alt="avatar" className="w-100 h-100" style={{ objectFit: "cover" }} src={avatarUrl} />
                ) : (
                    <span className="fw-bold fs-7 text-secondary">{senderName?.charAt(0) || "?"}</span>
                )}
            </div>
            
            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                <div className="d-flex align-items-center justify-content-between mb-1">
                    <span className="fs-9 fw-bold text-dark text-truncate d-block">{senderName || "Customer"}</span>
                    <span className="fs-10 text-muted flex-shrink-0 ms-2" style={{ fontSize: "10px" }}>{caseCreatedDate}</span>
                </div>
                
                <div className="d-flex align-items-center gap-2 mt-1">
                    <span className={cx("badge-amber", "rounded px-1")} style={{ fontSize: "10px", paddingBottom: "2px", paddingTop: "2px", fontWeight: "bold" }}>
                        Pending
                    </span>
                    <span className="fs-10 text-muted text-truncate d-block">
                        {castType}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default CasePendingCard;